import React, {Component} from 'react';
import { Nav,Carousel,Button,Row,Col, } from 'react-bootstrap';
import $ from 'jquery'
import Footer from './Footer'
import Fixed from './Fixed'
import './all.css'
import news_banner from '../img/news_banner.jpg'
import map from '../img/map.jpg'
import hjqxyl from '../img/hjqxyl.png'
import './all.css'


class AboutIntroduce extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div>
                <Row className='margin0'>
                    <img className="d-block w-100" src={news_banner} />
                </Row>
                <Row className="justify-content-md-center text-center" >
                    <Col xs={12} lg={8} style={{background:'#fff'}}>
                        <Nav className="justify-content-center about_nav" activeKey="/aboutIntroduce">
                            {/* <Nav.Item>
                                <Nav.Link href="/aboutService">全球服务网络</Nav.Link>
                            </Nav.Item> */}
                            <Nav.Item>
                                <Nav.Link href="/aboutIntroduce">润脉技术介绍</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="/contact">联系我们</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col lg={8}  style={{background:'#fff',margin:'2% 0',padding:'2%',lineHeight:'30px'}}>
                            <div style={{marginBottom:'3%'}}>  中医，这种高擎东方世界观与哲学观的智慧在5000年的物竞天择中不断演变，在无数前人同疾病作斗争的经验中总结形成。Raymedy正是在中医的核心经脉理论结合西医病理学，运用电磁波共振原理，为家庭和医疗机构提供专业的健康分析和干预方案。
                            </div>
                            <div>  Raymedy的理论基础源于前苏联一批顶级科学家15年的研究，最早应用在太空为宇航员进行健康管理。1997年由 Mauk在荷兰创建，在欧洲已有20年临床运用实践经验，全球超过1000家专业医疗机构和诊所使用，以百分之95的推荐率成为全球能量医学之冠，备受世界能量医学界瞩目和专业人士的信服。Raymedy系统在2004年获欧洲医疗设备2A证书认证。2016年润脉中国开始为国家科技部重点研发课题（*体现在字幕，不计入配音：《基于大数据的人体健康管理系统在冠心病抗栓治疗中的应用》项目编号2016YFC1301400）提供全部产品与数据分析服务。该课题由中国人民解放军总医院（*301医院）牵头，北京朝阳医院， 第三军医大学新桥医院、上海交通大学附属瑞金医院，南京第一医院等一批国内顶尖心血管外科医院联合研究，是我国医学史上第一次基于大数据的中西医结合临床研究。 </div>
                            <div style={{margin:'3% 0'}}>  Raymedy的核心理论融合了印度阿育吠陀与中西医理念，认为人由信息、能量和物质组成，是一个不可分割的整体。干预通过APP和测量设备，对经脉进行实时评估，以聆听身体的声音。用无线电波与可见光，远距离激发身体深处的某特定自然生理过程，通过72个经脉养护方案和无数个性化健康电子药方经提示独立完成，来帮助身体重新恢复自然平衡。这一切当然离不开世界顶级权威科学家、Raymedy国际科研团队、独有的疤痕及慢性病管理预防方案和无数电子药方的支持。有了这样强大的技术理论支撑以及欧洲丰富的临床经验，润家宝有信心做好您随身携带的24小时专属“保健医生”，为您和家人的健康护航。</div>
                            <div>  传统中医的数字化、科学化，将带来全球发展动力，加入我们！让古老的华夏璀璨真正走入您的生活，“没有全面健康，就没有全面小康”。这个世上，除了健康，都是小事。加入我们，一起将方便节约、疗效显著的个性化健康管理献给中国！</div>
                    </Col>
                </Row>
                <Footer/>
                <Fixed/>
            </div>
        )
    }
}

export default AboutIntroduce;

